export default __webpack_public_path__ + "static/media/data_presentation.24707327.svg";